import React from 'react'

import { Qn2cFeature } from 'components/pages/quarantineAction/Qn2cFeature'

// Page for handling quarantine actions via QnC2 feature
const QuarantineAction = () => (
  // Creates an instance of Qnc2Feature component
  <Qn2cFeature />
)

export default QuarantineAction
